/**
 * Object representing available answer options.
 * Each key corresponds to a specific answer and its value is of type `SelectedAnswer`.
 * @type {Record<string, import("../../pages/EquipActionPortal/questionTypes").SelectedAnswer>}
 */
export const answerOptions = {
  YES: 'YES',
  NO: 'NO',
  UNSURE: 'UNSURE',
  NONE_SELECTED: 'NONE_SELECTED',
};
